import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import LogoDirecaoWhiteSVG from '../../assets/logos/LogosBlackAndWhite/ModeDefault.svg'

import HeaderOptions from '../HeaderOptions'
import Img from 'react-webp-image'

import { BurgerMenu, Container, HeaderWrapper } from './styles'
import { GiHamburgerMenu } from 'react-icons/gi'
import MobileSidebar from './MobileSidebar'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'

const HomeHeader: React.FC = () => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false)
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  return (
    <Container>
      <HeaderWrapper>
        <div style={{ maxWidth: '50px' }}>
          <BurgerMenu onClick={() => setOpenMobileMenu(!openMobileMenu)}>
            <GiHamburgerMenu size={24} />
          </BurgerMenu>
        </div>
        <Link to="/home">
          {isDarkMode ? (
            <Img src={LogoDirecaoWhiteSVG} alt="Direção Concursos" className="logoDirecaoDark" />
          ) : (
            <Img src={LogoDirecaoWhiteSVG} alt="Direção Concursos" className="logoDirecaoLight" />
          )}
        </Link>
        <HeaderOptions />
      </HeaderWrapper>
      <MobileSidebar open={openMobileMenu} closeMenu={() => setOpenMobileMenu(false)} />
    </Container>
  )
}

export default HomeHeader
